module.exports = __webpack_public_path__ + "img/v1.3.675730e5.jpg";